import * as React from 'react';

import { LoginLink, SignUpLink } from '@mdlinx/component-library';

export const alternativeSceneLink = (args: {
  alternativeScene?: 'sign-up' | 'login';
  onLoginLinkClicked: () => void;
  onSignUpLinkClicked: () => void;
}) => {
  switch (args.alternativeScene) {
    case 'login':
      return <LoginLink onLoginLinkClicked={args.onLoginLinkClicked} />;
    case 'sign-up':
      return <SignUpLink onSignUpLinkClicked={args.onSignUpLinkClicked} />;
    default:
      return null;
  }
};
